import { FormGroup, FormControl, FormBuilder, Validators, FormGroupDirective } from '@angular/forms';
import { Component, OnInit, Input, ElementRef, ViewChild } from '@angular/core';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { LoaderService } from '@teem/services/loader.service';
import { OrderService } from '@teem/app/core/services/order.service';
import Swal from 'sweetalert2';
import { messages as i18n } from '@teem/constants/messages';

@Component({
  selector: 'app-order-oto',
  templateUrl: './order-oto.component.html',
  styleUrls: ['./order-oto.component.scss']
})

export class OrderOtoComponent implements OnInit {
	@Input('order') order;
	orderForm: FormGroup;
	submitted: boolean = false;

	constructor(
		private fb: FormBuilder,
		public activeModal: NgbActiveModal,
		private el: ElementRef,
		private orderService: OrderService,
		private loaderService: LoaderService,
	) {
	}

	ngOnInit() {
		this.orderForm = this.fb.group({
			package_count: [ '', [Validators.required, Validators.min(1)]],
			weight: [ '', [Validators.required]],
			width: [ '', [Validators.required, Validators.min(10)]],
			length: [ '', [Validators.required, Validators.min(10)]],
			height: ['', [Validators.required, Validators.min(10)]],
			other_information: ['']
		});
	}

	get f() {
		return this.orderForm.controls;
	}

	submit() {
		this.submitted = true;
		if (this.orderForm.valid) {
			let fd = this.orderForm.value;
			fd.uuid = this.order.uuid;
			this.loaderService.startLoading();
			this.orderService.createOtoOrder(fd).subscribe((data: any) => {
				this.loaderService.stopLoading();
				Swal.fire(i18n.done, data.message, 'success');
				this.activeModal.close(data);
			}, err => {
				this.loaderService.stopLoading();
				if (err.status == 422) {
					if (err.error && err.error.errors && Object.keys(err.error.errors).length) {
						let validationErrors = err.error.errors;
						Object.keys(validationErrors).forEach((prop) => {
							this.orderForm.get(prop)?.setErrors({
								serverError: validationErrors[prop]
							})
						})
					}
				}
				Swal.fire(i18n.alert.error, i18n.getError(err), 'error');
			})
		}
	}


}
